









































import { defineComponent, reactive, toRefs, PropType, computed, watch, onMounted, ref } from '@vue/composition-api';
import http from "../plugins/http";

export interface Data {
  is_disp_score_position_edit_tab: boolean
}

export default defineComponent({
  props: {
    tabNo: {
      type: Number as PropType<number>,
      required: true
    }
  },
  setup (props, context) {

    const state = reactive<Data>({
      is_disp_score_position_edit_tab: false,
    });

    const toHomeworkEdit = () => {
      if(context.root.$route.name != "HomeworkSheetEditNew"){
        context.root.$router.push(`/teacher_site/homework_sheet_edit/${context.root.$route.params.sheet_group_key}`).catch(err => {});
      }
    }

    const toAnswerImageUpload = () => {
      if(context.root.$route.name != "HomeworkSheetEditNew"){
        context.root.$router.push(`/teacher_site/homework_answer_image_upload/${context.root.$route.params.sheet_group_key}`).catch(err => {});
      }
    }

    const toPositionEdit = () => {
      if(context.root.$route.name != "HomeworkSheetEditNew"){
        context.root.$router.push(`/teacher_site/homework_position_edit/${context.root.$route.params.sheet_group_key}`).catch(err => {});
      }
    }

    const toScorePositionEdit = () => {
      if(context.root.$route.name != "HomeworkSheetEditNew"){
        context.root.$router.push(`/teacher_site/score_position_edit/${context.root.$route.params.sheet_group_key}`).catch(err => {});
      }
    }

    const toQuestionImageUpload = () => {
      if(context.root.$route.name != "HomeworkSheetEditNew"){
        context.root.$router.push(`/teacher_site/question_image_upload/${context.root.$route.params.sheet_group_key}`).catch(err => {});
      }
    }

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      await http.get(`/api/teacher/homework_sheet_edit/is_disp_score_position_edit_tab/${context.root.$route.params.sheet_group_key}`).then(response => {
        state.is_disp_score_position_edit_tab = response.data.is_disp_score_position_edit_tab;
      })
    });

    const modalShown = () => {
      const movieRoot = document.getElementById("movie-root");
      const img = document.createElement("img");
      const timestamp = new Date().getTime()
      img.src = require(`@/assets/gif/movie_field_position_setting.gif`) + "?" + timestamp
      img.style.width = "100%";
      movieRoot.appendChild(img);
    }

    
    return {
      ...toRefs(state),
      toHomeworkEdit,
      toAnswerImageUpload,
      toPositionEdit,
      toScorePositionEdit,
      toQuestionImageUpload,
      modalShown,
    }
  }
});
